module.exports = __webpack_public_path__ + "static/media/fotoliaImage.4abbd7c0.png";